import React from 'react';
import { ETATS, SOURCES, dateFr } from '../services/format';

// Petits éléments partagés par les pages de la console.

export function Etat({ etat, jusquau }) {
  const e = ETATS[etat] || ETATS.inconnu;
  return (
    <span className={`rg-etat ${e.classe}`} title={jusquau ? `Valable jusqu'au ${dateFr(jusquau)}` : undefined}>
      {e.label}{etat === 'accorde' && jusquau ? ` · ${dateFr(jusquau)}` : ''}
    </span>
  );
}

export function Source({ code }) {
  return <span>{SOURCES[code] || code || '—'}</span>;
}

export function Erreur({ message }) {
  if (!message) return null;
  return <div className="rg-erreur-bandeau" role="alert">{message}</div>;
}

export function Chargement() {
  return <p className="rg-info">Chargement…</p>;
}

export function Vide({ children }) {
  return <div className="rg-vide">{children}</div>;
}

export function messageErreur(e, defaut = 'Erreur inattendue') {
  return e?.response?.data?.error || e?.response?.data?.message || e?.message || defaut;
}
